import React from 'react'

class FooterBar extends React.Component {

    render() {
        return (
            <div id='footerbar' style={{ color: '#6c7d8f' }}>
                <div style={{ padding: "20px", borderBottom: "1px #ddd solid", width: "1000px", margin: "0 auto" }}>
                    <div style={{ padding: "2px 5px", display: "inline-block" }}>
                        <a style={{ color: '#6c7d8f' }} href='https://www.chuangkit.com' target='_blank'>创客贴</a>
                    </div>
                    <div style={{ padding: "2px 5px", display: "inline-block" }}>
                        <a style={{ color: '#6c7d8f' }} href='https://www.ibaotu.com' target='_blank'>包图网</a>
                    </div>
                    <div style={{ padding: "2px 5px", display: "inline-block" }}>
                        <a style={{ color: '#6c7d8f' }} href='https://www.1ppt.com' target='_blank'>第一PPT</a>
                    </div>
                    <div style={{ padding: "2px 5px", display: "inline-block" }}>
                        <a style={{ color: '#6c7d8f' }} href='https://www.58pic.com' target='_blank'>千图网</a>
                    </div>
                    <div style={{ padding: "2px 5px", display: "inline-block" }}>
                        <a style={{ color: '#6c7d8f' }} href='https://www.processon.com' target='_blank'>ProcessOn</a>
                    </div>
                    <div style={{ padding: "2px 5px", display: "inline-block" }}>
                        <a style={{ color: '#6c7d8f' }} href='https://www.liuchengtu.com' target='_blank'>迅捷画图</a>
                    </div>
                    <div style={{ padding: "2px 5px", display: "inline-block" }}>
                        <a style={{ color: '#6c7d8f' }} href='https://wwww.edrawsoft.cn' target='_blank'>edraw亿图</a>
                    </div>
                    <div style={{ padding: "2px 5px", display: "inline-block" }}>
                        <a style={{ color: '#6c7d8f' }} href='https://www.canva.cn' target='_blank'>Canva可画</a>
                    </div>
                    <div style={{ padding: "2px 5px", display: "inline-block" }}>
                        <a style={{ color: '#6c7d8f' }} href='https://www.meipian.cn' target='_blank'>美篇</a>
                    </div>
                    <div style={{ padding: "2px 5px", display: "inline-block" }}>
                        <a style={{ color: '#6c7d8f' }} href='https://www.tukuppt.com' target='_blank'>熊猫办公</a>
                    </div>
                    <div style={{ padding: "2px 5px", display: "inline-block" }}>
                        <a style={{ color: '#6c7d8f' }} href='https://www.xmind.cn' target='_blank'>Xmind思维导图</a>
                    </div>
                    <div style={{ padding: "2px 5px", display: "inline-block" }}>
                        <a style={{ color: '#6c7d8f' }} href='https://www.51miz.com' target='_blank'>觅知网</a>
                    </div>
                    <div style={{ padding: "2px 5px", display: "inline-block" }}>
                        <a style={{ color: '#6c7d8f' }} href='https://www.xiaohuazhuo.com' target='_blank'>小画桌</a>
                    </div>
                    <div style={{ padding: "2px 5px", display: "inline-block" }}>
                        <a style={{ color: '#6c7d8f' }} href='https://www.ztupic.com' target='_blank'>众图网</a>
                    </div>
                    <div style={{ padding: "2px 5px", display: "inline-block" }}>
                        <a style={{ color: '#6c7d8f' }} href='https://www.logosc.cn' target='_blank'>标小智</a>
                    </div>
                    <div style={{ padding: "2px 5px", display: "inline-block" }}>
                        <a style={{ color: '#6c7d8f' }} href='https://ai-bot.cn' target='_blank'>AI工具集</a>
                    </div>
                    <div style={{ padding: "2px 5px", display: "inline-block" }}>
                        <a style={{ color: '#6c7d8f' }} href='https://www.yutu.cn' target='_blank'>自学设计</a>
                    </div>
                    <div style={{ padding: "2px 5px", display: "inline-block" }}>
                        <a style={{ color: '#6c7d8f' }} href='https://www.design006.com' target='_blank'>共享设计</a>
                    </div>
                    <div style={{ padding: "2px 5px", display: "inline-block" }}>
                        <a style={{ color: '#6c7d8f' }} href='https://www.17font.com' target='_blank'>字体视界</a>
                    </div>
                </div>
                <div style={{ padding: "20px" }}>
                    Copyright ©2024 元纹&nbsp;
                    {<a style={{ color: '#6c7d8f' }} href='https://beian.miit.gov.cn' target="_blank" rel="noopener noreferrer">京ICP备20012803号-3</a>}
                    &nbsp;|&nbsp;
                    {<a style={{ color: '#6c7d8f' }} href='https://beian.mps.gov.cn' target="_blank" rel="noopener noreferrer">京公网安备11010802043958号</a>}
                </div>
            </div>
        )
    }
}

export default FooterBar